import { render, staticRenderFns } from "./DialogActiveAuthPackage.vue?vue&type=template&id=29641230&scoped=true&"
import script from "./DialogActiveAuthPackage.vue?vue&type=script&lang=js&"
export * from "./DialogActiveAuthPackage.vue?vue&type=script&lang=js&"
import style0 from "./DialogActiveAuthPackage.vue?vue&type=style&index=0&id=29641230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29641230",
  null
  
)

export default component.exports